let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("k1w8t"), load("35VQy"), load("6vzdH"), load("cLErX"), load("hkGfe"), load("c37CC")]).then(() => parcelRequire('cVptH'));